/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgEarthquakeCover32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M.5 22h31M18.03 29.138l-1.278-1.132 1.5-2.81-3.708.005L12.926 22M20 29.5l-1 1.25M3.882 21.901l-.99-4.126a3.158 3.158 0 01.477-2.538l5.215-7.511a3.159 3.159 0 013.13-1.312l6.3 1.086 3.498-2.905a4.854 4.854 0 015.44-.52l2.753 1.513a.9.9 0 01.302 1.308l-3.057 4.331M23.2 16.377l-3.981 5.54M18.016 7.5L8.004 21.705'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M24.207 10.615a3.287 3.287 0 011.064 6.485 3.287 3.287 0 01-1.064-6.485v0z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M24.016 6.38l1.92-2.905'
      />
      <path
        fill='#fff'
        fillRule='evenodd'
        d='M7.016 9.5l3.19.776a.188.188 0 01.138.228l-.58 2.405a.243.243 0 00.255.3l1.703-.123'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M7.016 9.5l3.19.776a.188.188 0 01.138.228l-.58 2.405a.243.243 0 00.255.3l1.703-.123'
      />
    </svg>
  );
}

export default SvgEarthquakeCover32;
